import { useResource } from "../../../Hooks/UseResource";

export default function FileResource() {
    const[resourceError, loading, getData, postData, uploadData] =useResource();

   const getUploadedContent =(filePath)=>{
        return postData( {url:'/public/get-file-content',data: {
            path: filePath  },});     
    }
    const getUploadedContentEnc =(filePath)=>{
        return postData( {url:'/public/get-enc-file-content',data: {
            encPath: filePath  },});     
    }


    return [getUploadedContent, getUploadedContentEnc]

}